import accountTableTemplate from './reactAccountsTable.html';
import { AccountService } from '../../../services/AccountService';
import { accounts, USER_ACC_REACT } from '../../../services/arsweb/RoutingPaths';
import { reactAccountCols, defaultSortModel, predefinedDefaultSortModel, predefinedNonMovSortModel } from './accountColDefs';
import { DETAIL_ACCOUNTROUTE } from '../../../views/accounts/AccountController';
import { ACCOUNTS_TITLE, NON_MOVEMENT_ACCOUNTS } from '../../../services/arsweb/TableTitles';
import {ReactTableController} from "../reactTableController";
import {EXPORT_TYPE} from "../../export/ExportModalController";
import {statementOptions} from "../../../views/administration/userReports/UserReportDetailDialogController";
import {DELETEROUTE, DELETETITLE} from "../administration/accounts/reactAdministrationAccountsTable.directive";

/** @ngInject */
export function reactAccountsTable() {
    return {
        restrict: 'E',
        scope: {
            filter: '=',
            subFilter: '=',
            tableId: '@',
            parentTableId: '@',
            mainCurrencies: '=',
            mainCurrenciesPromise: '=',
            parentController: '=',
            hideColumns: '=',
            tabName: '=',
            noLink: '=' // when true, the click event won't open the account detail
        },
        templateUrl: accountTableTemplate,
        controller: ReactAccountsTableController,
        controllerAs: 'accountsTableController'
    };
}

/** @ngInject */
export class ReactAccountsTableController extends ReactTableController {

    constructor($scope, userService, arsMainDependencies ) {

        super($scope, userService, arsMainDependencies, DETAIL_ACCOUNTROUTE, new AccountService(userService), accounts,
          ACCOUNTS_TITLE, 'accountTableParams' + $scope.tabName, "accountName", false, statementOptions,
            $scope.parentController.predefinedQuery ?
                ($scope.parentController.predefinedQuery.predefinedQuery === NON_MOVEMENT_ACCOUNTS ?
                    predefinedNonMovSortModel : predefinedDefaultSortModel)
                : defaultSortModel);
        $scope.$on('consolidationCurrency.change', () => this.resetGridSelection());
        $scope.$on('dateSnapshot.change', (event, date) => {
            this.backendService.service.config.params.filter = {dateTo : date};
            this.resetGridSelection();
        });

        $scope.$on('predefinedQuery', (event, params) => {
            this.backendService.service.config.params.filter = {predefinedQuery: params.predefinedQuery ,
                dateFrom: params.dateFrom};
            this.resetGridSelection();
        });


        this.backendService.service.config.params.filter = {dateTo : this.$rootScope.pickedDate};
        if(this.$scope.parentController.predefinedQuery) {
            this.backendService.service.config.params.filter = this.$scope.parentController.predefinedQuery;
        } else {
            this.supportedExports.push(EXPORT_TYPE.PDF_ACCOUNT_OVERVIEW);
        }

        if(this.$scope.filter && !_.isNil(this.$scope.filter)) {
            if(this.$scope.tableId.indexOf('accountGroup') !== -1) {
                this.dataFilter([]); //filter for collapsed tables
            }
        }
        this.ftsMainDependencies.initCompletedPromise.then(() => this.initGrid(userService));
    }

    initGrid(userService) {

        const hideFilters = this.$scope.tabName ? [this.$scope.tabName] : [];
        if(this.$scope.tabName) {
            if(this.$scope.tabName !== this.$scope.parentController.tabNameId) {
                hideFilters.push(this.$scope.parentController.tabNameId);
            }
        }
        if(this.$scope.parentController.predefinedQuery) {
            delete this.defaultReactGridParams.onSearchInputChange;
            delete this.defaultReactGridParams.onReport;
            this.globalActions.push({label: this.translate.instant(DELETETITLE),
                handleAction:() => this.delete(this.gridApi.getSelectedNodes(),DELETEROUTE + 'Confirmation')});
        }
        userService.promise.then(()=> {

            // react account columns
            this.colDefs = reactAccountCols(this.translate, userService, hideFilters);
            if(this.$scope.parentController.predefinedQuery) {
                // predefinedQuery cols def.
                this.colDefs.push({
                    field: "lastStatementDate",
                    headerName: this.translate.instant('LAST_STATEMENT_DATE'),
                    sortable: true,
                    filter: 'agDateColumnFilter',
                    filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
                    valueGetter: (params) => {
                        return params.data ?
                            userService.filterFormatter('fsDateNoLocal')( params.data.lastStatementDate) : "";
                    }
                });

                if(this.$scope.parentController.predefinedQuery.predefinedQuery === NON_MOVEMENT_ACCOUNTS) {
                    // accountName col. is 3rd & currency col is 5th on this grid
                    const accNameCol = this.colDefs.splice(0, 1)[0];
                    this.colDefs.splice(2, 0, accNameCol);
                    const currCol = this.colDefs.splice(6, 1)[0];
                    this.colDefs.splice(3, 0, currCol);
                }
            }

            this.initCols();
            // react gridParameters for account table
            const accountGridParams = {
                columnDefs: this.colDefs,
                columnMapping: {'currencyCode' : 'currency', "countryName": "country"},
                url: this.backendService.service.getServiceUrl(USER_ACC_REACT + accounts)};

            this.reactGridParams = {...this.defaultReactGridParams, ...accountGridParams};
        });
    }
}
